import router from '@/router'
import { getH5Applet } from '@/api/h5Applet'
// import Layout from '@/layout/index'
// import ParentView from '@/components/ParentView';

const applet = {
    state: {
        applet: {},
        judgeResult: ''
    },
    mutations: {
        SET_APPLET: (state, applet) => {
            // console.log('-----', applet)
            state.applet = applet
        },
        SET_JudgeResult: (state, judge) => {
            console.log('SET_JudgeResult-----', judge)
            state.judgeResult = judge
        }
    },
    actions: {
        // 生成路由
        GetH5AppletByAppletId ({ commit }, _applet) {
            return new Promise(resolve => {

                // 向后端请求路由数据
                getH5Applet(_applet).then(res => {
                    commit('SET_APPLET', res.data)
                    resolve(res.data)
                })
            })
        },
        // 生成路由
        setJudgeResult ({ commit }, _judge) {
            commit('SET_JudgeResult', _judge)
        }
    }
}

export default applet



// WEBPACK FOOTER //
// ./src/store/modules/applet.js